<template>
  <div class="com-chatroom-card" @click="onCLickChatRoomCard">
    <OutOpen
      :protocol="heyboxProtocol"
      :page-identifier="'bbs/link'"
      v-if="canUseDeepLink && articleInfo.source == 'share'"
    ></OutOpen>
    <template v-if="!is_loading">
      <template v-if="card_data">
        <div class="chatroom-thumb">
          <img :src="card_data.room_avatar" alt="" class="chatroom-thumb-img" />
        </div>
        <div class="info-section">
          <p class="chatroom-title">{{ card_data.room_name }}</p>
          <div class="line-2">
            <p class="online-count">{{ card_data.online_count }}在线</p>
            <p class="room-count">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
              >
                <g clip-path="url(#clip0_834_15)">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M6.31872 5.45759C7.02787 5.0164 7.49992 4.23 7.49992 3.33334C7.49992 1.95262 6.38063 0.833336 4.99992 0.833336C3.61921 0.833336 2.49992 1.95262 2.49992 3.33334C2.49992 4.23 2.97197 5.0164 3.68112 5.45759C2.06754 5.71067 0.833252 7.10703 0.833252 8.79167C0.833252 8.99878 1.00114 9.16667 1.20825 9.16667H8.79159C8.99869 9.16667 9.16659 8.99878 9.16659 8.79167C9.16659 7.10703 7.9323 5.71067 6.31872 5.45759Z"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_834_15">
                    <rect width="10" height="10" />
                  </clipPath>
                </defs>
              </svg>
              {{ card_data.member_count }}
            </p>
            <div class="static-color-room-entry">进入房间</div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="chatroom-thumb no-logo">
          <img
            class="chatroom-thumb-img"
            src="https://imgheybox.max-c.com/oa/2024/01/17/42081fe4d9067ccb78f308385d05c7b6.png"
          />
        </div>
        <div class="info-section">
          <p class="chatroom-title">链接已失效</p>
          <div class="line-2">
            <p class="default-desc">仍可以前往体验黑盒语音</p>
            <div class="static-color-room-entry">点击体验</div>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import { CptMixin } from '../../../mixins/CptMixin';
import { executeProtocol, executeProtocolOutApp } from '_lib/utils';
import OutOpen from '_com/OutOpen';
export default {
  mixins: [CptMixin],
  props: {
    canUseDeepLink: {
      type: Boolean,
    },
  },
  data() {
    return {
      is_loading: true,
      card_data: {},
    };
  },
  created() {
    this.getData();
  },
  components: {
    OutOpen,
  },
  methods: {
    async getData() {
      const {
        data: { result, status },
      } = await this.dataInfo.request;
      if (status != 'ok') {
        return;
      }
      this.card_data = result.list.find(
        (item) => item.invite_code == this.dataInfo.id,
      );
      this.is_loading = false;
      // console.log('[chatroom]:', this.card_data);
    },
    onCLickChatRoomCard() {
      switch (this.articleInfo.source) {
        case 'share': {
          executeProtocolOutApp(this.heyboxProtocol);
          break;
        }
        case 'post': {
          executeProtocol(this.heyboxProtocol);
          break;
        }
      }
    },
  },
  computed: {
    heyboxProtocol() {
      let protocol = this.card_data
        ? this.card_data.protocol
        : // eslint-disable-next-line
          `heybox://{"need_login":1,"path":"/flutter/heybox_voice","params":{"mini_program": "1", "mini_program_id":"${IS_PRO ? '207' : '82'}"},"protocol_type":"openRouterPath"}`;
      return protocol;
    },
  },
};
</script>

<style lang="less">
.com-chatroom-card {
  position: relative;
  display: flex;
  height: 74px;
  margin-top: 12px;
  padding: 12px 10px 12px 12px;
  border-radius: 8px;
  background: rgba(250, 251, 252, 1);
  &::after {
    content: '';
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    width: 200%;
    height: 200%;
    border-radius: 16px;
    border: 1px solid rgba(243, 244, 245, 1);
    transform: scale(0.5);
    transform-origin: left top;
    pointer-events: none;
  }
  .chatroom-thumb {
    position: relative;
    height: 50px;
    width: 50px;
    border-radius: 5px;
    overflow: hidden;
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 14px;
      height: 14px;
      border-radius: 2px;
      background:
        left 2px top ~'2px / 10px' 10px url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFVSURBVHgB7VXtccIwDH3h+r8Zwd0gGzQjdARv0DABsEE7QdoJYIOs0E4QNigbuNJheqaRnHMwHMfx7gSJvp4kRwlwx62j4B/nXEV/r8iLb5INyeKf/r0oii944rXLD0vSC3ouBjNfxSfy4oPkkcQIts3RHVXSuTzoSWqSH8HWDsogpVGcU9EwgaDn3ObA93C4oAPfkmFOl884DTsSK+hXzPHHh2HnViGfU+AOEfiOOgzPdkuxTxgJrpQRLjECZcQuHPFYgmVqArd/oCYVHCYpnbyDXSRG8u+RikgHjeC7UHxrTAEFvgnJeC3KwMcopC2mIjLyNvDpBDvHGJwCSvCidMRHYRWbRQ5Euqpj08hBrL1Oee3WWUcskDcCMRdTBUU1OAeUkXe+qPSdTSDWVocfwDIl1yzF2X9dVoLJjH1AssAd7/b5RiwQh2tkcEm4/cvD4o5rxy/5AqlITb76cAAAAABJRU5ErkJggg==)
          no-repeat,
        rgba(2, 25, 48, 0.6);
    }
    &.no-logo {
      &::before {
        display: none;
      }
    }
    .chatroom-thumb-img {
      width: 100%;
      height: 100%;
      border-radius: 5px;
      object-fit: cover;
    }
  }
  .info-section {
    flex: 1;
    width: 0;
    margin-left: 10px;
    padding-top: 3px;
    .chatroom-title {
      width: 100%;
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
      color: #14191e;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .line-2 {
      display: flex;
      align-items: flex-end;
      height: 24px;
      margin-top: 0px;
      .default-desc {
        font-size: 12px;
        line-height: 16px;
        color: rgba(140, 145, 150, 1);
      }
      .online-count {
        display: flex;
        align-items: center;
        font-size: 12px;
        line-height: 16px;
        color: rgba(140, 145, 150, 1);
        &::before {
          content: '';
          display: block;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: rgba(36, 165, 77, 1) !important;
          margin-right: 3px;
        }
      }
      .room-count {
        display: flex;
        align-items: center;
        margin-left: 8px;
        font-size: 12px;
        line-height: 16px;
        color: rgba(140, 145, 150, 1);
        svg {
          margin-right: 2px;
          fill: rgba(140, 145, 150, 1);
          path {
            fill: inherit;
          }
        }
      }
      .static-color-room-entry {
        box-sizing: border-box;
        height: 24px;
        margin-left: auto;
        margin-top: 0px;
        padding: 4px 8px;
        border-radius: 3px;
        font-size: 12px;
        line-height: 16px;
        color: rgba(255, 255, 255, 1);
        background: rgba(36, 165, 77, 1);
      }
    }
  }
}
</style>
